/**
 * Customer-facing online order number (e.g. ONL-1283).
 * Internal invoice numbers (184-1783591033755-9603) stay in URLs/API only.
 */

export function getOrderFrontOrderId(order) {
  if (!order) return "";
  return String(
    order.recvorder_FrontOrderID ??
      order.Recvorder_FrontOrderID ??
      order.frontOrderId ??
      order.FrontOrderId ??
      ""
  ).trim();
}

/**
 * Normalize what customers type on Track Order (e.g. "ONL - 86" → "ONL-86").
 * Also safe for internal invoice numbers.
 */
export function normalizeOrderReference(raw) {
  let value = String(raw ?? "").trim();
  if (!value) return "";

  value = value.replace(/\s*-\s*/g, "-").replace(/\s+/g, "");

  const onlBare = value.match(/^onl(\d+)$/i);
  if (onlBare) return `ONL-${onlBare[1]}`;

  const onlHyphen = value.match(/^onl-(.+)$/i);
  if (onlHyphen) return `ONL-${onlHyphen[1]}`;

  return value;
}

export function isFrontOrderReference(raw) {
  return /^ONL-/i.test(normalizeOrderReference(raw) || String(raw || "").trim());
}

/**
 * @param {object|string|null|undefined} orderOrFrontId
 * @param {string} [invoiceFallback]
 */
export function formatCustomerOrderNumber(orderOrFrontId, invoiceFallback = "") {
  if (typeof orderOrFrontId === "string") {
    const trimmed = normalizeOrderReference(orderOrFrontId) || orderOrFrontId.trim();
    if (trimmed) return trimmed;
  } else if (orderOrFrontId && typeof orderOrFrontId === "object") {
    const front = getOrderFrontOrderId(orderOrFrontId);
    if (front) return normalizeOrderReference(front) || front;
  }

  const invoice = String(invoiceFallback || "").trim();
  return invoice || "";
}

/** Match an order from My Orders by ONL-* or invoice. */
export function findOrderByCustomerReference(orders, reference) {
  const ref = normalizeOrderReference(reference) || String(reference || "").trim();
  if (!ref || !Array.isArray(orders)) return null;
  const refLower = ref.toLowerCase();

  return (
    orders.find((o) => {
      const front = normalizeOrderReference(getOrderFrontOrderId(o)).toLowerCase();
      const invoice = String(o?.recvorder_InvoiceNo ?? o?.Recvorder_InvoiceNo ?? "")
        .trim()
        .toLowerCase();
      return (front && front === refLower) || (invoice && invoice === refLower);
    }) || null
  );
}
